import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { VoiceCreationService } from "@/services/integrations/elevenlabs/VoiceCreationService";
import { VoiceRemixRequest, VoicePreviewResponse } from "@/types/voice/voice-creation";

const voiceCreationService = VoiceCreationService.getInstance();

export const useVoiceRemixPreview = () => {
  return useMutation<VoicePreviewResponse, Error, VoiceRemixRequest>({
    mutationFn: (payload) => voiceCreationService.remixVoice(payload),
    onError: (error) => {
      console.error("Voice remix preview failed:", error);
      toast.error("Failed to generate remix previews.");
    },
  });
};
